<!--
 * @Author:
 * @LastEditTime: 2023-09-22 19:55:42
 * @Description: 新增、编辑模型
-->
<template>
  <div>
    <el-dialog
      class="mid-dialog"
      v-dialogDrag
      :append-to-body="true"
      :visible.sync="batchUploadProps.visible"
      :title="batchUploadProps.title"
      :close-on-click-modal="false"
      @close="close(false)"
    >
      <el-form
        :model="batchUploadForm"
        :rules="modelTreeFormRules"
        ref="batchUploadForm"
        label-width="150px"
        :disabled="batchUploadProps.editType === 'read'"
      >
        <el-form-item label="上传压缩文件" prop="modelFile">
          <form-upload
            @change="fileIdChange"
            v-model="batchUploadForm.modelFile"
            :maxSize="30"
            :accept="['zip']"
            :disabled="tableFormDisabled"
            :tipShow="false"
            :isTemp="true"
          ></form-upload>
        </el-form-item>
        <el-form-item label="注意" prop="defaultSty">
          <div class="max-w-490px leading-22px text-14px text-hex-101010">
            zip中需要按照正确的目录结构放置素材文件，上传完成后服务端会自动完成素材归档。
            正确的目录结构请参考以下结构。素材名称目录下是具体的素材文件及描述、标签等文本文件。
          </div>
          <div class="batch__tree mt-20px">
            <el-tree :data="tipTree" :default-expand-all="true" :disabled="true"></el-tree>
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="flex justify-center" v-if="batchUploadProps.editType !== 'read'">
        <el-button
          size="small"
          type="primary"
          @click="save()"
          :loading="saveLoading"
          >保存</el-button
        >
        <el-button size="small" @click="close(false)">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { ModelApi, AnimationApi } from '@wiz-api/material-management'
import { assign, map, isArray, get } from 'lodash'

// 动效管理时替换 api为animationApi
const modelApi = new ModelApi()
const animationApi = new AnimationApi()
const FormUpload = () => {
  return import('./FormUpload')
}

export default {
  name: 'batchModelUpload',
  components: {
    FormUpload,
  },
  props: {
    // 当前选中目录
    currentTreeSelect: {
      type: Object,
      default: () => {
        return {}
      },
    },
    // 当前弹框操作类型描述
    batchUploadProps: {
      type: Object,
      default: () => {
        return {
          visible: true,
          title: '批量上传模型',
          editType: 'create',
        }
      },
    },
    // 页面信息 默认为模型库页面
    pageInfo: {
      type: Object,
      default: () => {
        return {
          pageTitle: '模型',
          materialType: 1,
        }
      },
    },
  },
  data() {
    return {
      // 上传表单
      batchUploadForm: {
        modelFile: '',
        defaultSty: true,
      },
      // 模型 压缩包上传格式提示树
      modelTipTree: [
        '素材包001.zip',
        [
          '模型库',
          ['建筑模型', ['xxx电厂模型', ['xxx电厂模型.pr'], ['Texture.zip'], ['xxx电厂模型.png']]],
          ['设备模型', ['汽轮机', ['汽轮机.pr'], ['Texture.zip'], ['汽轮机.png']]],
        ],
      ],
      // 动效 压缩包上传格式提示树
      kineticTipTree: [
        '素材包001.zip',
        ['动效库', ['火焰粒子', ['喷射火焰.efk'], ['Texture.zip'], ['喷射火焰.png']]],
      ],
      // 表单保存状态
      saveLoading: false,
      // 请求实例
      requestInstance: null,
    }
  },
  computed: {
    // 弹框标题
    pageTitle() {
      return get(this.pageInfo, 'pageTitle')
    },
    modelTreeFormRules() {
      return {
        modelFile: [
          {
            required: true,
            message: `请上传${this.pageTitle}文件`,
            trigger: 'blur',
          },
        ],
        defaultSty: [
          {
            required: true,
          },
        ],
      }
    },
  },
  methods: {
    // 数组数据转化为提示树
    transformTree(targetList, resultTree = {}) {
      if (!isArray(targetList)) {
        return resultTree
      }
      const [label, ...remainList] = targetList
      resultTree = assign(resultTree, {
        label,
        children: map(remainList, (item) => {
          const itemTree = this.transformTree(item, {})
          return itemTree
        }),
      })
      return resultTree
    },
    // 关闭
    close(isSuccess) {
      this.$emit('closeBatchModelUploadDialog', isSuccess)
    },
    // 文件改变
    fileIdChange(val) {},
    save() {
      this.$refs.batchUploadForm.validate(async (valid) => {
        if (valid) {
          this.saveLoading = true
          const [err] = await this.requestInstance.uploadMaterial({
            tempFileId: this.batchUploadForm.modelFile,
          })
          this.saveLoading = false
          if (!err) {
            this.$message.success(`新增${this.pageTitle}成功`)
            this.close(true)
          }
        }
      })
    },
  },
  created() {
    const { materialType } = this.$route.meta
    switch (materialType) {
      case 1:
        this.requestInstance = modelApi
        this.tipTree = [this.transformTree(this.modelTipTree, {})]
        break
      case 2:
        // 动效管理时替换 api为animationApi
        this.requestInstance = animationApi
        this.tipTree = [this.transformTree(this.kineticTipTree, {})]
        break
      default:
        break
    }
  },
}
</script>

<style lang="scss" scoped>
.batch__tree {
  ::v-deep {
    .el-tree-node {
      &__label {
        color: var(--systemMainColor);
      }
      &__expand-icon {
        display: none;
      }
    }
  }
}
</style>
